import React, { useEffect, useState, useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Coin from "../../Assets/coin.svg";
import SidePoster from "../SidePoster/SidePoster";
import { getQuestions } from "../../API/Question";
import { toast, ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { addUser } from "../../GlobalStorage/actions/user";
import { getUser } from "../../API/Auth";
import GoogleAds from "../../GoogleAds";
import { ClientID } from "../../GlobalStorage/actions/client";
import { CheckComponent } from "../../LoadContext";
import { sendData } from "../../API/Question";
import Login from "../Register/Login";
import useAnalyticsEventTracker from "../../useAnalyticsEventTracker";
const Starter = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [qData, setQData] = useState(null);
  const { startLoad, checkPage } = useContext(CheckComponent);
  const [data, setData] = useState(null);
  const [count, setCount] = useState(0);
  const [correctCount, setCorrectCount] = useState(0);
  const [ans, setAns] = useState(null);
  const [correct, setCorrect] = useState(null);
  const [wrong, setWrong] = useState(null);
  const trackEvent = useAnalyticsEventTracker();
  let userData = useSelector((state) => state.userData);
  let refreshUser = useSelector((state) => state.refreshUser);
  let { cat } = useParams();

  const isMobile = () => {
    let check = false;
    ((a) => {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  };
  let onMobile = isMobile();
  let clientid = useSelector((state) => state.clientId);
  // console.log(cat);
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  let teams = [];
  for (const p of searchParams) {
    teams.push(p[1]);
  }
  let subdomain = window.location.href.split("//")[1].split(".")[0];
  if (subdomain === "soapopera") {
    subdomain = "soaps";
  }
  useEffect(() => {
    if (
      localStorage.getItem("localCoins") == null &&
      localStorage.getItem("quizData") == null &&
      localStorage.getItem("userData") == null
    ) {
      checkPage();
      console.log("checkpage function ran");
    }
  }, []);
  useEffect(() => {
    const getdata = async () => {
      let res = await getUser();
      if (res.error == null) {
        dispatch(addUser(res.data.data));
        history.push("/home");
      }
    };
    getdata();
  }, [refreshUser]);
  let fromLogin;
  if (props.location.state) {
    fromLogin = props.location.state;
    // console.log(fromResult.fromResult);
    // console.log("fromLogin", fromLogin)
  }

  const next = (key) => {
    let result = null;
    if (key == data.correct) {
      setCorrect(data.correct);
      setCorrectCount((prev) => prev + 1);
      result = true;
    } else {
      setCorrect(data.correct);
      setWrong(key);
      result = false;
    }
    setTimeout(() => {
      setAns(result);
    }, 1000);
  };
  let preload = true;
  useEffect(() => {
    function getMultipleRandom(arr, num) {
      const shuffled = [...arr].sort(() => 0.5 - Math.random());
      return shuffled.slice(0, num);
    }
    const pullQuestions = async () => {
      if (
        (localStorage.getItem("localCoins") != null || userData != null) &&
        cat !== "t20" &&
        cat !== "football"
      ) {
        history.push("/home");
      } else if (cat) {
        let startQs = await getQuestions(null, null, null, true);
        if (cat === "t20" || cat === "football") {
          // console.log("questions of t20 world cup");
          // console.log(startQs ,"line 74");

          let filtered = startQs?.data?.data?.filter(
            (item) =>
              item.quizName ===
                (teams[0] === "" || teams[0] === "undefined"
                  ? "iplNewQuiz"
                  : teams[0]) ||
              item.quizName ===
                (teams[1] === "" || teams[1] === "undefined"
                  ? "iplNewQuiz"
                  : teams[1])
          );
          // console.log(filtered)
          let random = getMultipleRandom(filtered, 10);
          // console.log(random);
          setQData(random);
        } else {
          let filtered = startQs.data.data.filter(
            (item) => item.quizName === cat
          );
          let random = getMultipleRandom(filtered, 3);
          setQData(random);
        }
      } else if (
        subdomain === "ncis" ||
        subdomain === "soaps" ||
        subdomain === "sudhir" ||
        subdomain === "kamal" ||
        subdomain === "novaneural" ||
        subdomain === "rinzler" ||
        subdomain === "lembark" ||
        subdomain === "lathiyainfotech" ||
        subdomain === "novaneural2" ||
        subdomain === "androtech" ||
        subdomain === "samsul" ||
        subdomain === "openweb" ||
        subdomain === "winacle" ||
        subdomain === "lewishamilton" ||
        subdomain === "lpbw1" ||
        subdomain === "sisterwives1" ||
        subdomain === "novaneural3" ||
        subdomain === "lolo" ||
        subdomain === "coreaspire" ||
        subdomain === "lembark2" ||
        subdomain === "hws" ||
        subdomain === "wooper1" ||
        subdomain === "wooper2" ||
        subdomain === "wooper3" ||
        subdomain === "wooper4" ||
        subdomain === "wooper5" ||
        subdomain === "wooper6" ||
        subdomain === "wooper7" ||
        subdomain === "novaneural4" ||
        subdomain === "newspaper24hr" ||
        subdomain === "mahadev" ||
        subdomain === "radheytechnology" ||
        subdomain === "bengalyojana" ||
        subdomain === "woxxin2" ||
        subdomain === "vuvu" ||
        subdomain === "radheytechnology2" ||
        subdomain === "defaultnew" ||
        subdomain === "capity" ||
        subdomain === "radheytechnology3" ||
        subdomain === "radheytechnology4" ||
        subdomain === "dino" ||
        subdomain === "lathiyainfotech2" ||
        subdomain === "shreenathinfotech" ||
        subdomain === "defaultnew2" ||
        subdomain === "defaultnew3" ||
        subdomain === "default5" ||
        subdomain === "default6" ||
        subdomain === "default7"
      ) {
        let startQs = await getQuestions(null, null, null, true);

        let filtered = startQs.data.data.filter((item) => {
          if (
            subdomain === "novaneural" ||
            subdomain === "rinzler" ||
            subdomain === "lathiyainfotech" ||
            subdomain === "novaneural2" ||
            subdomain === "androtech" ||
            subdomain === "samsul" ||
            subdomain === "openweb" ||
            subdomain === "novaneural3" ||
            subdomain === "lolo" ||
            subdomain === "coreaspire" ||
            subdomain === "hws" ||
            subdomain === "wooper1" ||
            subdomain === "wooper2" ||
            subdomain === "wooper3" ||
            subdomain === "wooper4" ||
            subdomain === "wooper5" ||
            subdomain === "wooper6" ||
            subdomain === "wooper7" ||
            subdomain === "novaneural4" ||
            subdomain === "newspaper24hr" ||
            subdomain === "mahadev" ||
            subdomain === "radheytechnology" ||
            subdomain === "bengalyojana" ||
            subdomain === "woxxin2" ||
            subdomain === "vuvu" ||
            subdomain === "radheytechnology2" ||
            subdomain === "defaultnew" ||
            subdomain === "capity" ||
            subdomain === "radheytechnology3" ||
            subdomain === "radheytechnology4" ||
            subdomain === "dino" ||
            subdomain === "lathiyainfotech2" ||
            subdomain === "shreenathinfotech" ||
            subdomain === "defaultnew2" ||
            subdomain === "defaultnew3"
          ) {
            return item.quizName === "rinzler";
          } else if (subdomain === "lewishamilton" || subdomain === "winacle") {
            return item.quizName === "winacle";
          } else if (subdomain === "lembark2") {
            return item.quizName === "lembark";
          } else if (
            subdomain === "default5" ||
            subdomain === "default6" ||
            subdomain === "default7"
          ) {
            return item.quizName === "ipl2023";
          } else {
            return item.quizName === subdomain;
          }
        });
        if (subdomain === "kamal") {
          let random = getMultipleRandom(filtered, 6);
          setQData(random);
        } else if (subdomain === "winacle" || subdomain === "lewishamilton") {
          let random = getMultipleRandom(filtered, 5);
          setQData(random);
        } else if (subdomain === "lpbw1" || subdomain === "sisterwives1") {
          let random = getMultipleRandom(filtered, 7);
          setQData(random);
        } else {
          let random = getMultipleRandom(filtered, 3);
          setQData(random);
        }
      } else {
        let startQs = await getQuestions(null, null, null, true);
        // console.log(startQs)
        if (startQs.error) {
          toast.error(startQs.error.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        } else {
          // console.log(startQs.data.data);
          let filtered = startQs.data.data.filter(
            (item) => item.language !== "hindi" && item.language !== "bengali"
          );

          // console.log(filtered);
          let random = getMultipleRandom(filtered, 3);

          setQData(random);
        }
      }
    };
    pullQuestions();
  }, []);

  useEffect(() => {
    if (qData) setData(qData[count]);
  }, [qData]);
  // console.log(qData)
  useEffect(() => {
    if (qData) setData(qData[count]);
  }, [count]);

  useEffect(() => {
    if (ans != null) {
      setCount((prev) => prev + 1);
      if (count === 2) {
        trackEvent(
          "Question Played",
          "User Played 3rd question",
          "Played 3rd question"
        );
      }
      // if (count === 1 && window.location.hostname !== "localhost") {
      //   const dataLog = async () => {
      //     const res = await sendData();
      //     console.log("res", res);
      //   };
      //   dataLog();
      // }
      if (qData.length <= count + 1) {
        if (cat === "t20") {
          history.push("/home/quizzes-play/T-20");
        } else {
          history.push("/home");
        }
        localStorage.clear();
        let guestCoins = { coins: correctCount * 50 };
        // console.log(guestCoins);
        localStorage.setItem("localCoins", JSON.stringify(guestCoins));
      } else {
        setCount(count + 1);
      }
    }
    setCorrect(null);
    setWrong(null);
    setAns(null);
  }, [ans]);

  const LoginEvent = () => {
    trackEvent("button", "Sign up from Starter", "Sign Up");
    history.push("/login");
  };

  // useEffect(() => {
  //   const script = document.createElement("script");
  //   script.innerText = `window.unibots = window.unibots || { cmd: [] };
  //   unibots.cmd.push(()=>{ unibotsPlayer("soaps"); });`;

  //   document.getElementById("div-ub-soaps").append(script);
  //   console.log(document.getElementById("div-ub-soaps"));
  // }, []);

  // useEffect(() => {
  //   window.unibots = window.unibots || { cmd: [] };
  //   window.unibots.cmd.push(() => {
  //     window.unibotsPlayer("soaps");
  //   });
  // }, []);

  return (
    <>
      {data && (
        <>
          <div className="text-white h-screen flex overflow-hidden">
            <div className="min-w-[520px] lgm:min-w-[360px] md:w-full md:min-w-full max-h-screen flex flex-col gap-3 py-3 px-2 items-center overflow-y-auto scrollhide box-border">
              <div className=" w-[350px]">
                <GoogleAds
                  clientId={clientid}
                  startLoad={startLoad}
                  preload={preload}
                  fromLogin={fromLogin}
                />
              </div>
              <div className="text-center font-bold text-18">
                Let's begin!
                <div className="flex gap-1 text-[12px] text-[#8789c3]">
                  Answer 3 questions and win
                  <img className="w-3 object-contain" src={Coin} alt="coins" />
                  150 free!
                </div>
              </div>
              <div className="w-3/5 min-h-[.1rem] mx-auto bg-gradient-to-r dark:from-[#40438000] dark:via-[#404380] dark:to-[#40438000]"></div>
              <div className=" text-[#bac8ff] font-bold">
                Question {count + 1}
                <span className="text-[13px]">/{qData?.length}</span>
              </div>
              <div className="text-lg font-bold px-10 text-center">
                {data?.question}
              </div>
              <div className="grid grid-cols-2 gap-3 px-3 min-w-full mt-4">
                {data.answers.map((data, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        backgroundColor: correct
                          ? correct == data
                            ? "green"
                            : wrong
                            ? wrong == data
                              ? "red"
                              : null
                            : null
                          : null,
                        borderColor: correct
                          ? correct == data
                            ? "green"
                            : wrong
                            ? wrong == data
                              ? "red"
                              : null
                            : null
                          : null,
                      }}
                      className="flex flex-col justify-center items-center text-[14px] py-2 min-h-[32px] bg-[#20213f] border-2 border-[#404380] rounded-full cursor-pointer"
                      onClick={() => next(data)}
                    >
                      {data}
                    </div>
                  );
                })}
              </div>
              {subdomain !== "soaps" && (
                <div className="w-3/5 min-h-[.1rem] mx-auto bg-gradient-to-r dark:from-[#40438000] dark:via-[#404380] dark:to-[#40438000]"></div>
              )}
              {/* {subdomain === "soaps" && <div id="div-ub-soaps"></div>} */}
              <div
                className="text-[#ffcc5b] font-bold cursor-pointer"
                onClick={() => LoginEvent()}
              >
                Sign-Up - Login
              </div>
              <div>
                {cat === "t20" && onMobile && (
                  <p
                    className="bg-blue-500 py-2 px-4 rounded-lg"
                    onClick={() => history.push(`/scorecard`)}
                  >
                    See Scorecard
                  </p>
                )}
              </div>
              <div className="w-3/5 min-h-[.1rem] mx-auto bg-gradient-to-r dark:from-[#40438000] dark:via-[#404380] dark:to-[#40438000]"></div>
              <div className="w-full pl-5">
                <div className="w-full font-bold text-lg">
                  Play Quiz and Win Coins!
                </div>
                <ul className="text-[#8789c3] text-[14px] list-disc my-3 px-4">
                  <li className="mb-2">
                    {" "}
                    Play Quizzes in 25+ categories like GK, Sports, Bollywood,
                    Business, Cricket & more!{" "}
                  </li>
                  <li className="mb-2">
                    {" "}
                    Compete with lakhs of other players!{" "}
                  </li>
                  <li className="mb-2"> Win coins for every game </li>
                  <li className="mb-2">
                    {" "}
                    Trusted by millions of other quiz enthusiasts like YOU!{" "}
                  </li>
                </ul>
              </div>
            </div>
            <SidePoster />
          </div>
        </>
      )}
    </>
  );
};

export default Starter;
